export const ROOM_STATUS_ON = 'on';
export const ROOM_STATUS_OFF = 'off';

export const ROOM_STATUS_LIST = [
  ROOM_STATUS_ON,
  ROOM_STATUS_OFF
];
